import { useCallback } from 'react';
import { useGenericAPIMutation } from 'hooks/mutations/useGenericAPIMutation';
import { QUESTIONNAIRE_QUERY_KEYS } from 'components/InvestorProfileBase/hooks/useQuestionnaire';

interface UseSetChosenRiskProps {
    clientId: string | number;
    withAccept?: boolean;
}

interface SetChosenRiskParams {
    id: string | number;
    productId: string | number;
    submissionId: string | number;
}

export const useSetChosenRisk = ({ clientId, withAccept = false }: UseSetChosenRiskProps) => {
    const setChosenRiskMutation = useGenericAPIMutation();
    const acceptRiskMutation = useGenericAPIMutation();

    const setChosenRisk = useCallback(async ({ id, productId, submissionId }: SetChosenRiskParams) => {
        await setChosenRiskMutation.mutateAsync({
            service: 'compliance',
            API: 'setChosenRisk',
            payload: { contactId: clientId, chosenRiskId: id },
            // When accepting, invalidate only after acceptRisk finalizes the submission.
            invalidateQueryKeys: withAccept ? null : QUESTIONNAIRE_QUERY_KEYS,
        });

        if (withAccept) {
            await acceptRiskMutation.mutateAsync({
                service: 'compliance',
                API: 'acceptRisk',
                payload: { contactId: clientId, ProductIds: [productId], SubmissionId: submissionId },
                invalidateQueryKeys: QUESTIONNAIRE_QUERY_KEYS,
            });
        }
    }, [clientId, withAccept, setChosenRiskMutation, acceptRiskMutation]);

    return {
        setChosenRisk,
        isSending: setChosenRiskMutation.isPending || acceptRiskMutation.isPending,
        error: setChosenRiskMutation.error || acceptRiskMutation.error,
    };
};
